<template>
	<div>
		<v-autocomplete
			solo
			v-model="reference"
			:items="bibliographicReferences"
			:loading="loading"
			:search-input.sync="search"
			hide-selected
			item-text="title"
			item-value="id"
			:label="$gettext('Bibliographic References')"
			:placeholder="$gettext('Search Bibliographic References...')"
			return-object
			outlined
			no-filter
			:no-data-text="$gettext('No results found')"
			@input="addReference"
			prepend-inner-icon="search"
			hide-details
		></v-autocomplete>
    <v-list flat class="mt-2">
      <v-list-item v-for="reference in selectedBibliographicReferences" :key="reference.id" color="primary" style="border: 1px solid #e0e0e0; border-radius: 5px">
        <v-list-item-content>
          <v-list-item-title>
            {{reference.title}}
          </v-list-item-title>
          <v-list-item-subtitle>
            <span v-if="reference.year" class="mr-1">{{reference.year}}</span>
            <span>{{reference.authors}}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="primary--text">
          <v-btn icon @click="removeReference(reference)">
            <v-icon color="primary">delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
	</div>
</template>

<script>
import axios from "axios";

export default {
  name: "SearchBibliographicReferences",
  props: ["selectedBibliographicReferences"],
  data: () => ({
    reference: null,
    bibliographicReferences: [],
    loading: false,
    search: null
  }),
  methods: {
    makeRequest(value, self) {
			clearTimeout(this._timerId);
			self.loading = true;

			this._timerId = setTimeout(() => {
				self.loading = true;
				console.log("API CALL");
				axios
					.get("/admin/bibliographic-references/search", {
						params: { keyword: value }
					})
					.then(response => {
            console.log(response.data);
            this.bibliographicReferences = response.data;
            this.loading = false;
          })
					.catch(error => {console.log(error); this.loading = false});
			}, 300);
		},
    removeReference(reference) {
      this.selectedBibliographicReferences.splice(this.selectedBibliographicReferences.indexOf(reference), 1);
    },
    addReference() {
			if (this.reference) {
				console.log(this.reference);
				var exist = false;
				for (var i = 0; i < this.selectedBibliographicReferences.length; i++) {
					if (this.selectedBibliographicReferences[i].id == this.reference.id) {
						exist = true;
						break;
					}
				}
				if (!exist) {
					//CALL API
					console.log("ADD REFERENCE");
          this.selectedBibliographicReferences.push(this.reference);
          this.reference = null;
          this.search = null;
				}
			}
		}
  },
  watch: {
		search(value) {
			if (!value) {
				return;
			}
			if(this.reference) return;
			this.bibliographicReferences = [];
			this.makeRequest(value, this);
		}
	}
}
</script>